/* Welcome pop-up: opens once per visitor after a delay or 30% scroll, sends the email to the
   Klaviyo list (starts the store's welcome flow), keeps a small "10% off" tab after "No thanks". */
(function () {
  var D = document, root = D.querySelector('[data-welcome]'); if (!root || root._init) return; root._init = true;
  var tab = D.querySelector('[data-wel-tab]'), dialog = root.querySelector('[role="dialog"]');
  var KEY = 'yuuma-welcome', TABKEY = 'yuuma-welcome-tab-off';
  var get = function (s, k) { try { return s.getItem(k); } catch (e) { return 'x'; } };
  var set = function (s, k, v) { try { s.setItem(k, v); } catch (e) {} };
  var editor = window.Shopify && Shopify.designMode;
  var prevFocus = null, timer = null;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function open() {
    if (!root.hidden) return;
    prevFocus = D.activeElement;
    root.hidden = false; D.documentElement.style.overflow = 'hidden'; if (window.yuState) window.yuState();
    if (tab) tab.hidden = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
    setTimeout(function () {
      var i = root.querySelector('#WelEmail');
      if (i && !matchMedia('(hover: none)').matches) i.focus({ preventScroll: true }); else { dialog.setAttribute('tabindex', '-1'); dialog.focus({ preventScroll: true }); }
    }, 150);
  }
  function close() {
    if (root.hidden) return;
    var claimed = !root.querySelector('[data-wel-done]').hidden;
    set(localStorage, KEY, claimed ? 'claimed' : 'dismissed');
    root.classList.remove('is-in');
    setTimeout(function () {
      root.hidden = true; D.documentElement.style.overflow = ''; if (window.yuState) window.yuState();
      if (!claimed && tab && get(sessionStorage, TABKEY) !== '1') tab.hidden = false;
      if (prevFocus && prevFocus.focus) prevFocus.focus({ preventScroll: true });
    }, reduce ? 0 : 560);
  }
  function busy() {
    var pc = D.getElementById('shopify-pc__banner');
    var consent = pc && pc.offsetHeight > 0 && getComputedStyle(pc).display !== 'none' && getComputedStyle(pc).visibility !== 'hidden';
    return consent || !!D.querySelector('.drawer.is-open, #Lightbox:not([hidden])') || !!D.querySelector('#yu-a11y.open');
  }
  function fire() {
    clearTimeout(timer); removeEventListener('scroll', onScroll);
    if (busy()) { timer = setTimeout(fire, 4000); return; }
    set(localStorage, KEY, 'shown'); open();
  }
  function onScroll() { var d = D.documentElement; if (scrollY > (d.scrollHeight - innerHeight) * 0.3) fire(); }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-wel-close]')) close(); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(dialog.querySelectorAll('button, a[href], input')).filter(function (x) { return x.offsetParent !== null; });
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  var form = root.querySelector('[data-wel-submit]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input'), err = root.querySelector('#WelErr'), em = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    err.hidden = true; input.removeAttribute('aria-invalid');
    var btn = form.querySelector('button'); btn.disabled = true;
    var company = root.getAttribute('data-company'), list = root.getAttribute('data-list');
    var done = function () {
      set(localStorage, KEY, 'claimed');
      if (root.getAttribute('data-apply')) fetch('/discount/' + encodeURIComponent(root.getAttribute('data-code')), { credentials: 'same-origin' }).catch(function () {});
      root.querySelector('[data-wel-form]').hidden = true; root.querySelector('[data-wel-done]').hidden = false;
      root.querySelector('[data-wel-done-title]').focus({ preventScroll: true });
    };
    var shopifyFallback = function () {
      var b = new URLSearchParams(); b.append('form_type', 'customer'); b.append('utf8', '✓'); b.append('contact[email]', em); b.append('contact[tags]', 'newsletter,welcome-popup');
      return fetch('/contact#welcome', { method: 'POST', body: b, credentials: 'same-origin' });
    };
    var req = company && list ? fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Theme welcome pop-up', profile: { data: { type: 'profile', attributes: { email: em, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); }) : Promise.reject();
    req.catch(shopifyFallback).then(done, done);
  });
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-wel-copy]'); if (!c) return;
    try { navigator.clipboard.writeText(root.getAttribute('data-code')); } catch (x) {}
    c.textContent = 'Copied'; setTimeout(function () { c.textContent = 'Copy'; }, 2200);
  });
  if (tab) {
    tab.querySelector('[data-wel-reopen]').addEventListener('click', open);
    tab.querySelector('[data-wel-tab-off]').addEventListener('click', function () { set(sessionStorage, TABKEY, '1'); tab.hidden = true; });
  }
  // Theme editor: open while the section is selected, never on its own
  D.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('[data-welcome]')) open(); });
  D.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('[data-welcome]')) close(); });
  if (editor) return;

  if (/welcome/.test(location.hash)) { setTimeout(open, 1200); return; }
  var st = get(localStorage, KEY);
  if (st === 'x') return;
  if (st === 'dismissed') { if (tab && get(sessionStorage, TABKEY) !== '1') tab.hidden = false; return; }
  if (st) return;
  timer = setTimeout(fire, (parseInt(root.getAttribute('data-delay'), 10) || 7) * 1000);
  addEventListener('scroll', onScroll, { passive: true });
})();
